<template>
  <div class="bubble text-left">
    <p class="text-title">邀请您填写对我们的意见反馈</p>
    <p class="text-content">
      如您对产品功能、使用体验上有改进建议意见，可以提交给我们。我们会第一时间反馈相关信息进行优化
    </p>
    <button class="message-btn" @click="goToStore">填写意见反馈</button>
  </div>
</template>

<script>
export default {
  name: 'Card',
  mounted() {
    this.$log.collect('SHOW', 'IM_FEEDBACK', {})
  },
  methods: {
    goToStore() {
      this.$log.collect('CLICK', 'IM_FEEDBACK', {})
      const feedbackUrl =
        'm2u://krn?bundleId=YtFeedback&componentName=feedback&from=IM'
      window.open(feedbackUrl)
    },
  },
}
</script>

<style lang="less" scoped>
.bubble {
  border-radius: 0.4rem;
  overflow: hidden;
  word-break: break-all;
  box-sizing: border-box;

  &.text-left {
    padding: 0.4rem 0.32rem;
    background-color: #fff;
    color: #4a505c;
    border-radius: 0.16rem;
  }

  .message-btn {
    background: #ff79b5;
    border-radius: 0.5rem;
    border: 0;
    height: 0.6rem;
    width: 2.08rem;
    font-size: 0.24rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
    margin-top: 0.24rem;
  }

  .text-title {
    font-size: 0.3rem;
    font-weight: 600;
    line-height: 120%;
    text-align: justify;
  }

  .text-content {
    font-size: 0.26rem;
    font-weight: 400;
    line-height: 150%;
    margin-top: 0.16rem;
    text-align: justify;
  }
}
</style>
